import { HeadingLevel, HeadingProvider } from '@front10/base-elements';
import { withQueryClient } from '@front10/container-elements';
import { I18nProvider } from '@react-aria/i18n';
import { OverlayProvider } from '@react-aria/overlays';
import * as React from 'react';
import { FiltersProvider, FilterContainerProps } from './Filters';

export interface TicketEventsProviderProps extends React.PropsWithChildren<{}> {
  locale?: string;
  headingLevelStart?: HeadingLevel;
  filters?: FilterContainerProps;
  prePopulation?: $TSFixMe;
}

export function TicketEventsProvider({
  locale,
  headingLevelStart = 1,
  filters,
  children,
  prePopulation
}: TicketEventsProviderProps) {
  return (
    <HeadingProvider level={headingLevelStart}>
      <OverlayProvider>
        <I18nProvider locale={locale || 'en'}>
          <FiltersProvider prePopulation={prePopulation?.filters} filters={filters}>
            {children}
          </FiltersProvider>
        </I18nProvider>
      </OverlayProvider>
    </HeadingProvider>
  );
}

export default withQueryClient(TicketEventsProvider);
